var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.91px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "human_resource",
    "data-name": "human resource"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.14,22.5V19.68a0,0,0,0,0-.05,0H7.27a2,2,0,0,1-1.95-2V14.86l-1.91-.95,1.9-3.81V9.47a7.86,7.86,0,0,1,7.13-8,7.61,7.61,0,0,1,8.14,7.62,10.49,10.49,0,0,1-2.86,7.2V22.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.95,
    cy: 10.09,
    r: 2.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.95,
    y1: 6.27,
    x2: 12.95,
    y2: 7.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.95,
    y1: 13.91,
    x2: 12.95,
    y2: 12.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.65,
    y1: 8.18,
    x2: 10.47,
    y2: 8.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.26,
    y1: 12,
    x2: 15.43,
    y2: 11.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.26,
    y1: 8.18,
    x2: 15.43,
    y2: 8.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.65,
    y1: 12,
    x2: 10.47,
    y2: 11.52
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadGear);
export default __webpack_public_path__ + "static/media/head-gear.3fa406ff262492cedff04623779e519b.svg";
export { ForwardRef as ReactComponent };